export default "__VITE_ASSET__CldGYxsU__"